export const footerData = {
  mainSection: {
    heading: "Helping you get back to your mission",
    cta: {
      text: "Start Today",
      link: import.meta.env.VITE_WEBSITE_URL + "/professional-services",
    },
  },
  support: {
    heading: "Support:",
    links: [
      {
        text: "info@grantyd.com",
        href: "mailto:info@grantyd.com",
        isExternal: true,
      },
      // {
      //   text: "Resources",
      //   link: "/resources",
      // },
      // {
      //   text: "FAQs",
      //   link: "/faqs",
      // },
    ],
  },
  company: {
    heading: "Company:",
    links: [
      {
        text: "About Us",
        link: "/about",
      },
    ],
  },
  social: {
    heading: "Follow Us:",
    links: [
      {
        platform: "instagram",
        url: "https://instagram.com/getgrantyd",
        icon: "InstagramIcon",
      },
      {
        platform: "linkedin",
        url: "https://linkedin.com/company/grantyd",
        icon: "LinkedInIcon",
      },
    ],
  },
  bottom: {
    copyright: `©${new Date().getFullYear()}, Syntactic Sugar, Inc. All rights reserved.`,
    legal: [
      {
        text: "Terms of Service",
        link: "/terms",
      },
      {
        text: "Privacy Policy",
        link: "/privacy",
      },
    ],
    cookieSettings: "Cookie Settings",
  },
};
